export const Permissions = {
  DASHBOARD: 'dashboard',
  NEW_DEALER_REGISTRATION: 'new_dealer_registration',
  DEALER_MEETING: 'dealer_meeting',
  ORDER_SUMMARY: 'order_summary',
  DEALER_ENGAGEMENT: 'dealer_engagement',
  DEALER_LIST: 'dealer_list',
  PIPELINE: 'pipeline',
  APPROVED_APP: 'approved_app',
  REJECTED_APP: 'rejected_app',
  OPEN_MEETING: 'open_meeting',
  MEETING_HISTORY: 'meeting_history',
  DEALER_BIRTHDAY: 'dealer_birthday',
  DEALER_MARRIAGE_ANNIVERSARY: 'dealer_marriage_anniversary',
  DEALER_WORK_ANNIVERSARY: 'dealer_work_anniversary',
  SET_GOAL: 'set_goal',
  CONTACT_US: 'contact_us',
  ADMIN_FUNCTIONALITY: 'admin_functionality',
  ADMIN_ASSIGN_DEALER_CODE: 'admin_assign_dealer_code',
  ADMIN_MANAGE_USER: 'admin_manage_user',
  ADMIN_MANAGE_DEALER: 'admin_manage_dealer',
  ADMIN_ASSIGN_TERRITORIES: 'admin_assign_territories',
  ADMIN_CHANGE_MANAGER: 'admin_change_manager',
  ADMIN_MANAGE_TERRITORIES: 'admin_manage_territories',
  ADMIN_PRODUCT_LISTS: 'admin_product_lists',
  ADMIN_HOLIDAYS: 'admin_holidays',
  LOGIN_REPORT: 'login_report',
  CNF_DASHBOARD: 'cnf_dashboard',
  CNF_OPEN_ORDER: 'open_order',
  CNF_FULFILLED_ORDER: 'fulfilled_order',
  ADMIN_USER: 'admin_user',

  // SURVEY_FORM: 'survey_form',
  SURVEY_FORM: 'survey_form',
  CRETAE_SURVEY: 'create_survey',

  DISTANCE_TRAVEL: 'distance_travel'
};
